// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2l_cO","footer":"Form_footer__2FQwf"};